"use client";

import Image from "next/image";
import Link from "next/link";
import React from "react";
import { useEffect, useState } from "react";
import { renderButtonStyle } from "../utils/render-button-style";

interface Picture {
  data: {
    id: string;
    attributes: {
      url: string;
      name: string;
      alternativeText: string;
    };
  };
}

interface BookDemoProps {
  data: {
    id: string;
    title: string;
    description: string;
    picture: Picture;
    image1: Picture;
    image2: Picture;
    btnLink: string;
    btnText: string;
    isLive: boolean;
    useH1Tag?: boolean;
  };
}

export default function BookDemo({ data }: BookDemoProps) {
  return (
    data.isLive && (
      <section className="relative mx-auto px-8 flex justify-center items-center lg:py-20 xl:py-20 md:py-12 py-12 bg-th-bg-col-rich overflow-hidden">
        <div className="lg:w-[834px] lg:h-[468px] md:h-[468px] h-[825px] bg-[#554A9E] rounded-3xl p-6 flex lg:flex-row md:flex-row flex-col justify-between items-center gap-4">
          <div className="text-center lg:w-[55%] md:w-[55%] w-full">
            {
              data?.useH1Tag ? (
                <h1 className="text-3xl text-white text-center font-bold mb-8">
              {data?.title?.split(" ").map((line, index, array) => (
                <React.Fragment key={index}>
                  {line == "Questions?" ? (
                    <span className="relative whitespace-nowrap text-orange-400">
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 418 42"
                        className="absolute top-[74%] left-[-1px] h-[16px] w-full fill-orange-300/70"
                        preserveAspectRatio="none"
                      >
                        <path d="M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.78 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.54-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.81 23.239-7.825 27.934-10.149 28.304-14.005.417-4.348-3.529-6-16.878-7.066Z"></path>
                      </svg>
                      <span className="relative">{line}</span>
                    </span>
                  ) : (
                    <span className="leading-snug">{line}</span>
                  )}
                  {index !== array.length - 1 && " "}
                </React.Fragment>
              ))}
            </h1>
              ) : (
                <h2 className="text-3xl text-white text-center font-bold mb-8">
              {data?.title?.split(" ").map((line, index, array) => (
                <React.Fragment key={index}>
                  {line == "Questions?" ? (
                    <span className="relative whitespace-nowrap text-orange-400">
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 418 42"
                        className="absolute top-[74%] left-[-1px] h-[16px] w-full fill-orange-300/70"
                        preserveAspectRatio="none"
                      >
                        <path d="M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.78 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.54-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.81 23.239-7.825 27.934-10.149 28.304-14.005.417-4.348-3.529-6-16.878-7.066Z"></path>
                      </svg>
                      <span className="relative">{line}</span>
                    </span>
                  ) : (
                    <span className="leading-snug">{line}</span>
                  )}
                  {index !== array.length - 1 && " "}
                </React.Fragment>
              ))}
            </h2>
              )
            }
            <p className="max-w-3xl mt-5 mx-auto text-lg text-gray-300">
              {data.description}
            </p>
            <div className="flex lg:flex-row md:flex-row flex-col justify-center items-center gap-4 mt-8">
              {data?.btnLink && (
                <div className="flex items-center justify-center text-center px-0 pb-0">
                  <button
                    onClick={() => window.scrollToAppointment()}
                    className={renderButtonStyle("primary")}
                  >
                    {data?.btnText}
                  </button>
                </div>
              )}
              <div className="flex items-center justify-center text-center px-0 pb-0">
                <button
                  onClick={() => window.scrollToAppointment()}
                  className={renderButtonStyle("primary")}
                >
                  Schedule a Call
                </button>
              </div>
            </div>
          </div>
          <div className="lg:w-[40%] md:w-[40%] w-full">
            <div className="w-[100%] h-[100%]">
              <Image
                src={
                  "https://oextech.blr1.digitaloceanspaces.com/AiCodePro/important/model-21.svg"
                }
                alt="demo-img"
                width={100}
                height={100}
                className="relative object-cover w-[100%] lg:h-auto md:h-[420px] h-[350px] top-[-5px] rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>
    )
  );
}
